import { createToast, toastType } from 'Common/ToastHelper';
import * as types from './types';

export const noteRowInfoUpdate = rowInfo => {
  return (dispatch, getState, MPWWebApi) => {
    const {
      StudentNotesState: { noteRowInfo },
    } = getState();

    if (rowInfo && rowInfo.isEmpty) {
      rowInfo = { Description: '' };
    } else {
      rowInfo = { ...noteRowInfo, ...rowInfo };
    }
    dispatch({
      type: types.STUDENT_NOTES_NOTEROWUPDATE,
      payload: rowInfo,
    });
  };
};

export const updateNotesComponentState = obj => {
  return (dispatch, getState, MPWWebApi) => {
    const {
      StudentNotesState: { notesState },
    } = getState();
    obj = { ...notesState, ...obj };
    dispatch({
      type: types.STUDENT_NOTES_UPDATENOTES,
      payload: obj,
    });
  };
};

export const getNotesInfo = (studentData, isApplicationNotes) => {
  return async (dispatch, getState, MPWWebApi) => {
    var url = `student/${studentData.IdSeed}/studentnote`;
    if (isApplicationNotes) {
      url = `HouseholdNote/${studentData.HouseholdId}`;
    }
    try {
      const response = await MPWWebApi.getGeneric(url);

      dispatch({
        type: types.STUDENT_NOTES_GET_NOTES,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: types.STUDENT_NOTES_GET_NOTES_ERROR,
        payload: error.response,
      });
      if (
        error.response.data &&
        error.response.data.Errors &&
        error.response.data.Errors[0].Title === null
      ) {
        createToast(
          toastType.error,
          'Error',
          'Unable to save get student notes',
          true
        );
      } else {
        error.response.data.Errors.map((errorValue, i) => {
          createToast(
            toastType.error,
            errorValue[i].Title,
            errorValue[i].Message,
            true
          );
          return null;
        });
      }
    }
  };
};

export const saveNotesInfo = (isNew, isApplicationNotes) => {
  return async (dispatch, getState, MPWWebApi) => {
    const {
      StudentNotesState: { noteRowInfo },
    } = getState();
    const idSeed = noteRowInfo.StudentIdSeed;
    let finalObj = {};
    if (isNew) {
      finalObj = { ...noteRowInfo, ...{ Id: 0, ReadOnly: 'N' } };
    } else {
      finalObj = noteRowInfo;
    }
    var url = `Student/${idSeed}/studentnote`;
    if (isApplicationNotes) {
      url = `HouseholdNote/Write`;
    }
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(url, finalObj);

      dispatch({
        type: types.STUDENT_NOTES_SAVE_NOTES,
        payload: response.data,
      });
      if (response.status === 200) {
        dispatch(
          getNotesInfo(
            {
              IdSeed: noteRowInfo.StudentIdSeed,
              HouseholdId: noteRowInfo.HouseholdId,
            },
            isApplicationNotes
          )
        );
        createToast(
          toastType.success,
          'Success',
          'Notes updated successfully',
          true
        );
      }
    } catch (error) {
      dispatch({
        type: types.STUDENT_NOTES_SAVE_NOTES_ERROR,
        payload: error.response,
      });
      if (
        error.response.data &&
        error.response.data.Errors &&
        error.response.data.Errors[0].Title === null
      ) {
        createToast(
          toastType.error,
          'Error',
          'Unable to save student notes',
          true
        );
      } else {
        error.response.data.Errors.map((errorValue, i) => {
          createToast(
            toastType.error,
            errorValue[i].Title,
            errorValue[i].Message,
            true
          );
          return null;
        });
      }
    }
  };
};

export const deleteNotesInfo = isApplicationNotes => {
  return async (dispatch, getState, MPWWebApi) => {
    const {
      StudentNotesState: { noteRowInfo },
    } = getState();
    const id = noteRowInfo.Id;
    let url = `Student/StudentNote`;
    if (isApplicationNotes) {
      url = `HouseholdNote`;
    }

    try {
      const response = await MPWWebApi.postGenericDelete(url, id);
      dispatch({
        type: types.STUDENT_NOTES_DELETE_NOTES,
        payload: response.data,
      });

      dispatch(
        getNotesInfo(
          {
            IdSeed: noteRowInfo.StudentIdSeed,
            HouseholdId: noteRowInfo.HouseholdId,
          },
          isApplicationNotes
        )
      );
      createToast(
        toastType.success,
        'Success',
        'Note deleted successfully',
        true
      );
    } catch (error) {
      dispatch({
        type: types.STUDENT_NOTES_DELETE_NOTES_ERROR,
        payload: error.response,
      });
      if (
        error.response.data &&
        error.response.data.Errors &&
        error.response.data.Errors[0].Title === null
      ) {
        createToast(toastType.error, 'Error', 'Unable to delete note', true);
      } else {
        error.response.data.Errors.map((errorValue, i) => {
          createToast(
            toastType.error,
            errorValue[i].Title,
            errorValue[i].Message,
            true
          );
          return null;
        });
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/common/Components/StudentNoteModal/state/actions.js